import CritrereTextController from './critere.text.controller';

export default {
    bindings: {
        critere: '='
    },
    controller: CritrereTextController,
    template: require('./critere.text.tpl.html')
};
